module.exports = __webpack_public_path__ + "img/linkedin.f6532cce.svg";